import jQuery from 'jquery'

window.$ = window.jQuery = jQuery



// WEBPACK FOOTER //
// ./resources/js/plugins/jquery.js